import { StorageStore } from './StorageStore';
export default StorageStore;
